<template>
  <div v-if="$store.state.conversationVisible" class="conversations-list">
    <!-- Header -->
    <div class="list-header">
      <h2>See your followers</h2>
      <button class="new-message-btn" @click="$refs.userList.show()">
        <svg style="min-width: 24px;height: 24px;" fill="white" width="800px" height="800px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title>ionicons-v5-j</title><circle cx="152" cy="184" r="72"/><path d="M234,296c-28.16-14.3-59.24-20-82-20-44.58,0-136,27.34-136,82v42H166V383.93c0-19,8-38.05,22-53.93C199.17,317.32,214.81,305.55,234,296Z"/><path d="M340,288c-52.07,0-156,32.16-156,96v48H496V384C496,320.16,392.07,288,340,288Z"/><circle cx="340" cy="168" r="88"/></svg>
      </button>
    </div>

    <!-- Search -->
    <div class="search-container">
      <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"/>
        <path d="m21 21-4.35-4.35"/>
      </svg>
      <input
        v-model="searchQuery"
        type="text"
        class="search-input"
        placeholder="Search conversations..."
      />
    </div>

    <!-- Conversations List -->
    <div class="conversations-container">
      <div
        v-for="conversation in filteredConversations"
        :key="conversation.userId"
        class="conversation-item"
        :class="{ unread: conversation.unreadCount > 0 }"
        @click="openConversation(conversation)"
      >
        <!-- Profile Photo -->
        <div class="conversation-avatar">
          <img :src="!conversation.avatar ? require('./img/profile.svg') : bsImgUrl+conversation.avatar" :alt="conversation.name" />
          <div v-if="!!this.onlineUsers[conversation.userId]" class="online-indicator"></div>
        </div>

        <!-- Conversation Info -->
        <div class="conversation-info">
          <div class="conversation-header">
            <div class="conversation-name">{{ conversation.name }}</div>
            <div class="conversation-time">{{ formatTime(conversation.lastMessage?.createdAt) }}</div>
          </div>
          <div class="conversation-preview">
            <span v-if="conversation.lastMessage?.senderId === currentUserId" class="you-prefix">You: </span>
            <span class="preview-text">{{ getMessagePreview(conversation.lastMessage) }}</span>
            <span v-if="conversation.unreadCount > 0" class="unread-badge">{{ conversation.unreadCount }}</span>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="conversations.length === 0" class="empty-state">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        <p>No conversations yet</p>
      </div>
    </div>
    <UserList ref="userList"/>
  </div>
</template>

<script>
import { resolvePendingMessagesSequential } from '@/views/conversation/routine'
import UserList from '@/views/components/userList/UserList.vue';

export default {
  name: 'ConversationsList',
  components: {
    UserList
  },
  data() {
    return {
      bsImgUrl:this.$store.state.baseUrl+'images/',
      searchQuery: '',
      conversations: [/*{
          userId: "userId",
          name: "Jean",
          avatar:'',
          lastMessage: {createdAt:new Date(),text:"bonjour je suis le liberateur du monde"},
          unreadCount: 3,
          messages: []
        },*/],
      onlineUsers: {},
      eventSource: null,
      heartbeatInterval: null,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      reconnectDelay: 3000
    }
  },
  computed: {
    currentUserId() {
      return this.$store.state.user?.uid;
    },
    filteredConversations() {
      if (!this.searchQuery.trim()) {
        return this.conversations;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.conversations.filter(conv => 
        conv.name.toLowerCase().includes(query) ||
        this.getMessagePreview(conv.lastMessage).toLowerCase().includes(query)
      );
    }
  },
  methods: {
    getOldMessages () {
      let i=0
      for(i=0;i<this.conversations.length;i++){
        const cv = this.conversations[i]
        this.$axios.post('chat.php',{type:"chatListMessage", userId:cv.userId,from:new Date()})
        .then(({data}) => {
          data = data || []
          console.log(data)
          // lets add the messages
          const k = this
          k.$store.commit('addMessagesToConversation', {
            userId: cv.userId,
            messages: data
          });
        }).catch(err => {
          console.error('loading message', err);
        });
      }
    },
    // there we get the 50 last user active chat
    // when opening a conversation, if no messages, we will use getOldMessage
    // this function will be executed once per login
    async getChats () {
      try {
        const res = await this.$axios.post('chat.php',{type:"listUserChats",from:new Date()})
        const chats = res.data || [], otherUserIds = []
        const user = this.$store.state.user.uid || JSON.parse(localStorage.getItem('currentUser__') || '{}')
        chats.forEach(chat => {
          const otherUser = chat.userId1 === user ? chat.userId2 : chat.userId1
          otherUserIds.push(otherUser)
        })
        //--- getting users data -----
        const  k = this
        const res2 = await this.$axios.post('user.php',{type:"getUsersMetaData",users:otherUserIds})
        const users = res2.data || []
        const conversations = []
        //--- saving
        users.forEach(us => {
          conversations.push({
            userId: us.uid,
            name: us.name,
            avatar: us.profilImgMini1,
            lastMessage: null,
            unreadCount: 0,
            messages:[]
          });
          k.$store.commit('setAnUser',us)
        })
        this.conversations = conversations
      } catch(err) {
        console.error('loading user chats', err);
      }
    },
    // Load conversations from store
    async getUserData () {
      const messages = this.$store.state.messages;
      let usersToGet = []
      for (const userId in messages) {
        if(!this.$store.state.users[userId]) usersToGet.push(userId) // if user not saved 
      }

      if(usersToGet.length === 0) return
      const k = this
      const res2 = await this.$axios.post('user.php',{type:"getUsersMetaData",users:usersToGet})
      const users = res2.data || []
      users.forEach(us => {
        k.$store.commit('setAnUser',us)
      })
      //------- update conversation ----------
      this.loadConversations()
      this.getOldMessages()
    },
    loadConversations() {
      const messages = this.$store.state.messages;
      if (!messages) return;

      const conversations = this.conversations;
      
      // Iterate through all user conversations
      for (const userId in messages) {
        const userMessages = messages[userId];
        if (!userMessages || userMessages.length === 0) continue;

        // Get last message
        const lastMessage = userMessages[userMessages.length - 1];
        
        // Count unread messages
        const unreadCount = userMessages.filter(msg => 
          msg.senderId === userId && 
          !msg.seenAt && 
          !msg.deletedAt
        ).length;

        // Get user info from contacts or last message
        const userInfo = this.getUserInfo(userId);
        const data = {
          userId: userId,
          name: userInfo.name,
          avatar: userInfo.avatar,
          lastMessage: lastMessage,
          unreadCount: unreadCount,
          messages:userMessages
        }
        let convIndex = this.conversations.findIndex(cv => cv.userId === userId)

        if(convIndex !== -1) {
          conversations[convIndex] = data // updating conversation
        }
        else conversations.push(data);
      }

      // Sort by last message time (most recent first)
      conversations.sort((a, b) => {
        const timeA = a.lastMessage?.createdAt ? new Date(a.lastMessage.createdAt) : 0;
        const timeB = b.lastMessage?.createdAt ? new Date(b.lastMessage.createdAt) : 0;
        return timeB - timeA;
      });

      this.conversations = conversations;
    },

    getUserInfo(userId) {
      // Try to get from contacts/friends in store
      const contacts = this.$store.state.users
      const contact = contacts[userId] || {}
      
      if (contact) {
        return {
          name: contact.name || 'unknown',
          avatar: contact.profilImgMini1
        };
      }

      // Fallback to basic info
      return {
        name: `User ${userId.substring(0, 8)}`,
        avatar: ''
      };
    },

    // Connect to SSE for real-time messages
    connectToMessages() {

      if (this.eventSource) {
        this.eventSource.close();
      }
      const baseUrl = this.$store.state.baseUrl || '';
      const accessToken = 'Bearer '+localStorage.getItem("access_token")
      // Remove trailing slash if exists
      const cleanUrl = baseUrl.replace(/\/$/, '');
      const url = `${cleanUrl}/realTime.php?token=${accessToken}`;

      this.eventSource = new EventSource(url);

      this.eventSource.onopen = () => {
        console.log('Connected to message stream');
        this.reconnectAttempts = 0;
      };

      this.eventSource.onmessage = (event) => {
        //console.log(event.data)
        try {
          const data = JSON.parse(event.data);
          
          if (data.type === 'heartbeat') {
            // Keep connection alive
            return;
          }

          if (data.type === 'unread_messages' && data.messages) {
            this.handleNewMessages(data.messages);
          }

          if (data.type === 'online_users' && data.users) {

            this.updateOnlineUsers(data.users);
          }
          if (data.type === 'message_modified' && data.messageId) {
            const otherUserId = this.$store.state.user.uid === data.senderId ? data.receiverId : data.senderId
            
            this.$store.commit('updateMessage', {
              userId: otherUserId,
              messageId: data.messageId,
              updates: data.updatedData
            });
          }
          if (data.type === 'messages_read') {
            this.handleMessagesRead(data.messageIds,data.receiverId);
          }
      
        } catch (error) {
          console.error('Error parsing message:', error);
        }
      };

      this.eventSource.onerror = (error) => {
        console.error('EventSource error:', error);
        this.eventSource.close();
        this.attemptReconnect();
      };
    },

    handleNewMessages(messages) {
      // Group messages by conversation (sender/receiver)
      const messagesByConversation = {};

      messages.forEach(msg => {
        // Determine the other user in the conversation
        const otherUserId = msg.senderId === this.currentUserId ? msg.receiverId : msg.senderId;
        
        if (!messagesByConversation[otherUserId]) {
          messagesByConversation[otherUserId] = [];
        }
        messagesByConversation[otherUserId].push(msg);
      });

      // Add messages to store for each conversation
      for (const userId in messagesByConversation) {
        const conversationMessages = messagesByConversation[userId];
        this.$store.commit('addMessagesToConversation', {
          userId: userId,
          messages: conversationMessages
        });
      }

      // Reload conversations to update UI
      //this.loadConversations();
      this.getUserData() // get user profile infos
    },

    updateOnlineUsers(onlineUsers) {
      const users = onlineUsers || []
      this.onlineUsers = []
      users.forEach(usr =>{
        this.onlineUsers[usr] = usr
      })
      this.$store.commit('setOnlineUserIds',this.onlineUsers)
    },

    stopHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
      }
    },

    attemptReconnect() {
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.error('Max reconnect attempts reached');
        return;
      }

      this.reconnectAttempts++;
      const delay = this.reconnectDelay * this.reconnectAttempts;
      
      console.log(`Reconnecting in ${delay}ms (attempt ${this.reconnectAttempts})`);
      
      setTimeout(() => {
        this.connectToMessages();
      }, delay);
    },

    signalOnlineStatus() {
      if (!this.currentUserId) return;

      // POST request to signal online (NOT via SSE)
      this.$axios.post('userStatus.php', {  // Changed from '/user-status/status'
        type: 'setOnline'
      }).catch(err => {
        console.error('Error signaling online status:', err);
      });
    },

    signalOfflineStatus() {
      if (!this.currentUserId) return;

      // Use sendBeacon for reliability when page is closing
      const baseUrl = this.$store.state.baseUrl;
      const data = JSON.stringify({ type: 'setOffline' });
      
      // sendBeacon with proper content type
      const blob = new Blob([data], { type: 'application/json' });
      navigator.sendBeacon(`${baseUrl}userStatus.php`, blob);
    },
    
     // 5. HANDLE MESSAGES READ - UPDATE STORE
    handleMessagesRead(messageIds,receivedId) {
      const messages = this.$store.state.messages[receivedId];

      if(!messages) return
      const ids = messageIds || []
      // Update each message that was read
      ids.forEach(messageId => {
        const message = messages.find(m => m._id === messageId);
        
        if (message) {
          this.$store.commit('updateMessage', {
            userId: receivedId,
            messageId: messageId,
            updates: {
              seenAt: new Date()
            }
          });
        }
      });
    },



    openConversation(conversation) {
      this.$store.commit('showChat', {uid:conversation.userId,name:conversation.name,profilImgMini1:conversation.avatar})
    },

    getMessagePreview(message) {
      if (!message) return 'No messages yet';
      
      if (message.deletedAt) return 'Message deleted';
      if (message.text) return message.text;
      if (message.img) return '📷 Photo';
      if (message.audio) return '🎵 Audio';
      if (message.callTime) return `📞 Call ${this.formatDuration(message.callTime)}`;
      
      return 'Message';
    },

    formatTime(timestamp) {
      if (!timestamp) return '';
      
      const date = new Date(timestamp);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'Just now';
      if (diffMins < 60) return `${diffMins}m`;
      if (diffHours < 24) return `${diffHours}h`;
      if (diffDays < 7) return `${diffDays}d`;
      
      return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    },

    formatDuration(seconds) {
      if (!seconds) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    close () {
      if(this.$store.state.publicationFormVisible) {
        this.$store.commit('setPublicationFormVisibility',false)
        return false
      }
      if(this.$store.state.chatSetting.visible) {
        this.$store.commit('closeChat')
        return false
      }
      if(this.$store.state.audioPlayerVisibility === true) {
        this.$store.commit('setAudioPlayerVisibility',false)
        return false
      }
      if(this.$refs.userList.visible) {
        this.$refs.userList.close()
        return false
      }
      return true
    }
  },
  watch: {
    "$store.state.messages": {
      handler() {
        console.log('updating conversation-----------')
        this.loadConversations()
      },
      deep: true
    },
    '$store.state.chatSetting.visible'() {
      resolvePendingMessagesSequential()
    }
  },
  mounted() {
    if(!localStorage.getItem('messages')) this.getChats() // if the localstorage message has never been set up
    // Load conversations from store
    //this.loadConversations();
    
    // Connect to real-time message stream
    this.connectToMessages();
    
    // Signal that user is online
    this.signalOnlineStatus();

    // Handle page visibility changes
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.signalOfflineStatus();
      } else {
        this.signalOnlineStatus();
        // Reconnect if connection was lost
        if (!this.eventSource || this.eventSource.readyState !== EventSource.OPEN) {
          this.connectToMessages();
        }
      }
    });

    // Handle before unload
    window.addEventListener('beforeunload', this.signalOfflineStatus);
  },

  beforeUnmount() {
    // Clean up
    if (this.eventSource) {
      this.eventSource.close();
    }
    this.stopHeartbeat();
    this.signalOfflineStatus();
    
    document.removeEventListener('visibilitychange', this.signalOnlineStatus);
    window.removeEventListener('beforeunload', this.signalOfflineStatus);
  }
}
</script>

<style scoped>
.conversations-list {
  background: #0a0e26;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* Header */
.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.15);
}

.list-header h2 {
  color: #e0f7ff;
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}

.new-message-btn {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  transition: all 0.3s;
}

.new-message-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 212, 255, 0.4);
}

.new-message-btn svg {
  width: 20px;
  height: 20px;
}

/* Search */
.search-container {
  position: relative;
  padding: 12px 20px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
}

.search-icon {
  position: absolute;
  left: 36px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: #94a3b8;
  pointer-events: none;
}

.search-input {
  width: 100%;
  background: rgba(30, 41, 59, 0.6);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 12px;
  padding: 10px 16px 10px 40px;
  color: #e0f7ff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s;
}

.search-input::placeholder {
  color: #94a3b8;
}

.search-input:focus {
  border-color: rgba(0, 212, 255, 0.5);
  background: rgba(30, 41, 59, 0.8);
}

/* Conversations Container */
.conversations-container {
  flex: 1;
  overflow-y: auto;
}

/* Conversation Item */
.conversation-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-bottom: 1px solid rgba(0, 212, 255, 0.05);
}
.conversation-item > * + * { margin-left: 12px; }

.conversation-item:hover {
  background: rgba(0, 212, 255, 0.1);
}

.conversation-item.unread {
  background: rgba(0, 212, 255, 0.05);
}

.conversation-avatar {
  position: relative;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
}

.conversation-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(0, 212, 255, 0.3);
}

.online-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  background: #22c55e;
  border: 2px solid #0a0e26;
  border-radius: 50%;
}

.conversation-info {
  flex: 1;
  min-width: 0;
}

.conversation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.conversation-name {
  color: #e0f7ff;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-time {
  color: #94a3b8;
  font-size: 12px;
  flex-shrink: 0;
  margin-left: 8px;
}

.conversation-preview {
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 14px;
}
.conversation-preview > * + * { margin-left: 8px; }


.you-prefix {
  color: #00d4ff;
  font-weight: 500;
}

.preview-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unread-badge {
  background: #00d4ff;
  color: #0a0e26;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  flex-shrink: 0;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
}

.empty-state svg {
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* Scrollbar */
.conversations-container::-webkit-scrollbar {
  width: 6px;
}

.conversations-container::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.3);
}

.conversations-container::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.3);
  border-radius: 3px;
}

.conversations-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.5);
}
</style>